/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CHECKOUT_CORE_FEATURE } from '../feature-name';
import { CheckoutState } from '../model/checkout-state.model';
import {QueryState} from "@lm-nx-frontend/lm-inf-core";
import {facadeFactory} from "../../../../../../lm-inf-core/src/lib/lazy-loading";

@Injectable({
  providedIn: 'root',
  useFactory: () =>
    facadeFactory({
      facade: CheckoutQueryFacade,
      feature: CHECKOUT_CORE_FEATURE,
      methods: ['getCheckoutDetailsState'],
    }),
})
export abstract class CheckoutQueryFacade {
  /**
   * Returns the checkout details state.
   */
  abstract getCheckoutDetailsState(): Observable<
    QueryState<CheckoutState | undefined>
  >;
}
